export type Language = 'en' | 'ar' | 'ha';

export const translations = {
    en: {
        'app.title': 'KCA Portal',
        'common.welcome': 'Welcome',
        'common.login': 'Login',
        'common.logout': 'Logout',
        'common.dashboard': 'Dashboard',
        'common.back': 'Back',
        'common.submit': 'Submit',
        'common.cancel': 'Cancel',
        'common.save': 'Save',
        'common.delete': 'Delete',
        'common.edit': 'Edit',
        'common.view': 'View',
        'common.loading': 'Loading...',
        'common.error': 'Error',
        'common.success': 'Success',
        'common.report': 'Report',
        'common.download_pdf': 'Download PDF',
        'common.term': 'Term',
        'common.session': 'Session',

        // Dashboard
        'dashboard.title': 'Student Dashboard',
        'dashboard.latest_term_average': 'Latest Term Average',
        'dashboard.attendance_rate': 'Attendance Rate',
        'dashboard.fees_status': 'Fees Status',
        'dashboard.outstanding': 'Outstanding',
        'dashboard.academic_performance_trend': 'Academic Performance Trend',
        'dashboard.announcements': 'Announcements',
        'dashboard.recent_results': 'Recent Results',
        'dashboard.view_all_grades': 'View All Grades',
        'dashboard.more_subjects': 'more subjects',

        // Live Classes
        'live_classes.title': 'Live Classes',
        'live_classes.join_class_now': 'Join Class Now',
        'live_classes.live': 'LIVE',
        'live_classes.no_active_sessions': 'No active live sessions at the moment.',
        'live_classes.no_live_classes': 'No live classes scheduled.',
        'live_classes.started': 'Started',

        // Feedback
        'feedback.title': 'Student Feedback',
        'feedback.subject': 'Subject',
        'feedback.type': 'Type',
        'feedback.submit_feedback': 'Submit Feedback',
        'feedback.no_feedback_submitted': 'No feedback submitted yet.',
        'feedback.general_feedback': 'General Feedback',
        'feedback.complaint': 'Complaint',
        'feedback.appeal': 'Appeal',
        'feedback.appreciation': 'Appreciation',
        'feedback.admin_response': 'Admin Response',
        'feedback.new_feedback': 'New Feedback',
        'feedback.brief_subject': 'Brief subject',
        'feedback.describe_feedback': 'Describe your feedback...',

        // Finance
        'finance.title': 'My Finance',
        'finance.balance': 'Balance',
        'finance.status': 'Status',
        'finance.invoices': 'Invoices',
        'finance.payment_history': 'Payment History',
        'finance.no_payment_history': 'No payment history found.',
        'finance.account_name': 'Account Name',
        'finance.account_number': 'Account Number',
        'finance.bank_name': 'Bank Name',
        'finance.total': 'Total',
        'finance.paid': 'Paid',
        'finance.action': 'Action',
        'finance.upload_proof': 'Upload Proof',
        'finance.pending_verification': 'Pending Verification',
        'finance.school_account_details': 'School Account Details',

        // Profile
        'profile.title': 'My Profile',
        'profile.student_information': 'Student Information',
        'profile.admission_date': 'Admission Date',
        'profile.date_of_birth': 'Date of Birth',
        'profile.gender': 'Gender',
        'profile.address': 'Address',

        // Portals
        'portal.admin': 'Admin Portal',
        'portal.teacher': 'Teacher Portal',
        'portal.student': 'Student Portal',
        'portal.parent': 'Parent Portal',

        // Auth
        'auth.email': 'Email',
        'auth.password': 'Password',
        'auth.signIn': 'Sign In',
        'auth.staffLogin': 'Access Login',
        'auth.forgotPassword': 'Forgot Password?',

        // Navigation
        'nav.home': 'Home',
        'nav.dashboard': 'Dashboard',
        'nav.students': 'Students',
        'nav.teachers': 'Teachers',
        'nav.classes': 'Classes',
        'nav.sections': 'Sections',
        'nav.reviews': 'Grade Reviews',
        'nav.attendance_logs': 'Attendance Logs',
        'nav.iqa_reviews': 'IQA Reviews',
        'nav.cbt_manager': 'CBT Manager',
        'nav.timetable': 'Timetable',
        'nav.live_classes': 'Virtual Classroom',
        'nav.announcements': 'Announcements',
        'nav.financial_management': 'Financial Management',
        'nav.operations': 'Operation Hub',
        'nav.staff_development': 'Observations',
        'nav.iqa': 'IQA',
        'nav.student_feedback': 'Student Feedback',
        'nav.analytics': 'Analytics',
        'nav.archives': 'Archives',
        'nav.cbt_hub': 'CBT Hub',
        'nav.eqa_audit': 'EQA Audit',
        'nav.settings': 'Settings',
        'nav.gradebook': 'Gradebook',
        'nav.iqa_forms': 'IQA Forms',
        'nav.attendance': 'Attendance',
        'nav.finance': 'My Finance',
        'nav.development': 'My Development',
        'nav.profile': 'My Profile',
        'nav.observations': 'Observations',
        'nav.academics': 'Academics',
        'nav.ai_tutor': 'AI Tutor',
        'nav.report_card': 'Report Card',
        'nav.cbt_exams': 'CBT Exams',
        'nav.my_timetable': 'My Timetable',
        'nav.feedback': 'Feedback',
        'nav.theme': 'Theme',

        // Academics
        'academics.title': 'Academics',
        'academics.subject': 'Subject',
        'academics.ca': 'CA',
        'academics.exam': 'Exam',
        'academics.total': 'Total',
        'academics.grade': 'Grade',
        'academics.remark': 'Remark',
        'academics.download_report_card': 'Download Report Card',

        // Exams
        'exams.title': 'CBT Exams',
        'exams.no_exams_scheduled': 'No exams scheduled at the moment.',
        'exams.mins': 'mins',
        'exams.start_exam': 'Start Exam',

        // Extended nav — Admin
        'nav.scholarships': 'Scholarships',
        'nav.messages': 'Messages',
        'nav.cbt_center': 'CBT Center',
        'nav.cambridge_exams': 'Cambridge Exams',
        'nav.cambridge_primary': 'Cambridge Primary Teacher',
        'nav.curriculum': 'Curriculum',
        'nav.tahfiz': 'Tahfiz Al-Quran',
        'nav.sampling_plan': 'Sampling Plan',
        'nav.standardization': 'Standardization',
        'nav.feedback_student': 'Student Feedback',
        'nav.feedback_teacher': 'Teacher Feedback',
        'nav.iqa_handbook': 'Digital Handbook',
        'nav.teacher_performance': 'Teacher Performance',
        'nav.admissions': 'Admissions',
        'nav.staff_attendance': 'Staff Attendance',
        'nav.admins': 'Admins',
        'nav.logout': 'Logout',

        // Extended nav — Teacher
        'nav.teach': 'Teach',
        'nav.musabaqa': 'Musabaqa Competition',
        'nav.games': 'Class Games',
        'nav.aicpd': 'CPD Courses',
        'nav.lms': 'LMS Instructor',
        'nav.external_students': 'External Students',
        'nav.handbook': 'Handbook',

        // Curriculum sub-items
        'nav.curr_early_years': 'Early Years (Playgroup – KG 2)',
        'nav.curr_primary': 'Primary (Grades 1 – 6)',
        'nav.curr_islamiyya_early': 'Early Years — Rauda',
        'nav.curr_islamiyya': 'Primary — Saudi MOE (Grades 1 – 6)',
        'nav.curr_tahfiz': 'Tahfiz Al-Quran — IQA',
        'nav.assign_curriculum': 'Assign Curriculum',

        // Observations sub
        'nav.obs_dashboard': 'Dashboard',

        // ── Tahfiz ──────────────────────────────────────────────────
        'tahfiz.hub_title': 'Tahfiz Assessment Hub',
        'tahfiz.teacher_portal_subtitle': 'Teacher Portal · Recitation Review',
        'tahfiz.awaiting_review': 'awaiting review',
        'tahfiz.all_caught_up': 'All caught up',
        'tahfiz.all_grades': 'All Grades',
        'tahfiz.students_enrolled': 'Students Enrolled',
        'tahfiz.avg_hizb': 'Avg Hizb Completed',
        'tahfiz.total_hizb': 'Total Hizb (School)',
        'tahfiz.completion_rate': 'Completion Rate',
        'tahfiz.total': 'Total',
        'tahfiz.graded': 'Graded',
        'tahfiz.pending': 'Pending',
        'tahfiz.class_filter': 'Class Filter',
        'tahfiz.filter_desc': 'Filter students, tasks, and submissions by class',
        'tahfiz.all_classes': 'All Classes (Show All)',
        'tahfiz.tab_submissions': 'Submissions',
        'tahfiz.tab_assign': 'Assign Tasks',
        'tahfiz.tab_progress': 'Progress',
        'tahfiz.tab_curriculum': 'Curriculum',
        'tahfiz.tab_analytics': 'Analytics',
        'tahfiz.tab_quran': 'Quran Reader',
        'tahfiz.tab_overview': 'Overview',
        'tahfiz.tab_goals': 'My Goals',
        'tahfiz.tab_tasks': 'My Tasks',
        'tahfiz.tab_record': 'Record',
        'tahfiz.tab_sessions': 'Sessions',
        'tahfiz.tab_achievements': 'Achievements',
        'tahfiz.tab_community': 'Community',
        'tahfiz.status_pending': 'Pending',
        'tahfiz.status_in_progress': 'In Progress',
        'tahfiz.status_submitted': 'Submitted',
        'tahfiz.status_reviewed': 'Reviewed',
        'tahfiz.status_overdue': 'Overdue',
        'tahfiz.grade_excellent': 'Excellent (A) — Mutqin',
        'tahfiz.grade_good': 'Good (B) — Solid',
        'tahfiz.grade_needs_revision': 'Needs Revision (C)',
        'tahfiz.grade_ungraded': 'Ungraded',
        'tahfiz.tajweed': 'Tajweed',
        'tahfiz.makharij': 'Makharij',
        'tahfiz.hifdh': 'Hifdh',
        'tahfiz.fluency': 'Fluency',
        'tahfiz.riwayah': 'Riwayah',
        'tahfiz.tarteel': 'Tarteel',
        'tahfiz.assign_task': 'Assign Task',
        'tahfiz.run_analysis': "Run Sheikh's Analysis",
        'tahfiz.analysing': 'Analysing…',
        'tahfiz.submit_review': 'Submit Review',
        'tahfiz.save_changes': 'Save Changes',
        'tahfiz.cancel': 'Cancel',
        'tahfiz.done': 'Done',
        'tahfiz.record_new': 'Record New',
        'tahfiz.stop': 'Stop',
        'tahfiz.re_record': 'Re-record',
        'tahfiz.record_correction': 'Record Correction',
        'tahfiz.discard_recording': '✕ Discard and re-record',
        'tahfiz.open_full_review': 'Open Full Review',
        'tahfiz.review_title': 'Review',
        'tahfiz.student_recording': 'Student Recording',
        'tahfiz.sheikh_analysis': "Sheikh's Analysis",
        'tahfiz.sheikh_analysis_en': "Sheikh's Analysis - English",
        'tahfiz.sheikh_analysis_ar': "Sheikh's Analysis - Arabic",
        'tahfiz.your_grade': 'Your Grade',
        'tahfiz.written_feedback': 'Written Feedback',
        'tahfiz.audio_correction': 'Audio Correction',
        'tahfiz.assign_task_title': 'Assign Memorisation Task',
        'tahfiz.task_monitor': 'Task Monitor',
        'tahfiz.submission_history': 'Submission History',
        'tahfiz.corrections': 'Corrections',
        'tahfiz.strengths': 'Strengths',
        'tahfiz.areas_to_improve': 'Areas to Improve',
        'tahfiz.teacher_notes': "Teacher's Notes",
        'tahfiz.audio_feedback': 'Audio Feedback',
        'tahfiz.admin_title': 'Tahfiz Administration',
        'tahfiz.admin_subtitle': 'School-wide · Quran Memorization Analytics',
        'tahfiz.live_dashboard': 'Live Dashboard',
        'tahfiz.active_students': 'Active Students',
        'tahfiz.verses_memorized': 'Verses Memorized',
        'tahfiz.avg_streak': 'Avg Streak',
        'tahfiz.avg_accuracy': 'Avg Accuracy',
        'tahfiz.pending_reviews': 'Pending Reviews',
        'tahfiz.perf_summary': 'Performance Summary',
        'tahfiz.teacher_activity': 'Teacher Activity',
        'tahfiz.student_rosters': 'Student Rosters',
        'tahfiz.community_groups': 'Community Groups',
        'tahfiz.juz_progress_map': 'School-wide Juz Progress Map',
        'tahfiz.students_completed_juz': 'Students who completed each Juz',
        'tahfiz.live_activity': 'Live Activity Feed',
        'tahfiz.leaderboard': 'Tahfiz Elite — School Leaderboard',
        'tahfiz.top_verses': 'Top Verses Memorized',
        'tahfiz.streak_champs': 'Streak Champions',
        'tahfiz.instructor_name': 'Instructor Name',
        'tahfiz.students_assigned': 'Students Assigned',
        'tahfiz.submissions_received': 'Submissions Received',
        'tahfiz.graded_reviews': 'Graded Reviews',
        'tahfiz.pending_queue': 'Pending Review Queue',
        'tahfiz.avg_student_accuracy': 'Average Student Accuracy',
        'tahfiz.student_name': 'Student Name',
        'tahfiz.grade_level': 'Grade Level',
        'tahfiz.instructor': 'Instructor',
        'tahfiz.current_juz': 'Current Juz',
        'tahfiz.accuracy': 'Accuracy',
        'tahfiz.active_streak': 'Active Streak',
        'tahfiz.status': 'Status',
        'tahfiz.day_streak': 'Day Streak',
        'tahfiz.full_quran': 'Full Quran',
        'tahfiz.loading': 'Loading Tahfiz Dashboard...',
        'tahfiz.verses': 'Verses',
        'tahfiz.juz_done': 'Juz Done',
        'tahfiz.pages': 'Pages',
        'tahfiz.active_goals': 'Active Goals',
        'tahfiz.juz_map': 'Juz Memorization Map',
        'tahfiz.recent_sessions': 'Recent Sessions',
        'tahfiz.badges': 'Badges',
        'tahfiz.set_new_goal': 'Set New Tahfiz Goal',
        'tahfiz.goal_type': 'Goal Type',
        'tahfiz.new_memorization': '📖 New Memorization',
        'tahfiz.muraja': "🔄 Muraja'ah (Review)",
        'tahfiz.target_days': 'Target Days',
        'tahfiz.daily_pace': 'Daily Pace',
        'tahfiz.create_goal': 'Create Goal',
        'tahfiz.no_goals': 'No goals set yet. Create your first memorization goal!',
        'tahfiz.completed': 'Completed',
        'tahfiz.recitation_studio': 'Recitation Studio',
        'tahfiz.record_ai_grade': 'Record, AI-grade, and submit to your Qari teacher',
        'tahfiz.recording_for_task': 'Recording for Assigned Task',
        'tahfiz.tap_to_record': 'Tap to begin recording',
        'tahfiz.recording_in_progress': '● Recording in progress...',
        'tahfiz.select_teacher': 'Select Teacher',
        'tahfiz.submitting': 'Submitting...',
        'tahfiz.submit_to_teacher': 'Submit to Teacher',
        'tahfiz.submitted_ok': 'Submitted Successfully!',
        'tahfiz.submitted_desc': 'Your teacher will review and provide feedback shortly.',
        'tahfiz.record_another': 'Record Another',
        'tahfiz.total_sessions': 'Total Sessions',
        'tahfiz.hours_invested': 'Hours Invested',
        'tahfiz.current_streak': 'Current Streak',
        'tahfiz.longest_streak': 'Longest Streak',
        'tahfiz.pages_memorized': 'Pages Memorized',
        'tahfiz.pages_reviewed': 'Pages Reviewed',
        'tahfiz.badges_earned': 'Badges Earned',
        'tahfiz.no_badges': 'No badges yet',
        'tahfiz.keep_practicing': 'Keep practicing to earn your first badge!',
        'tahfiz.community_title': 'Community & Leaderboards',
        'tahfiz.community_subtitle': 'Tahfiz Circles · Challenges · Rankings',
        'tahfiz.leaderboards': 'Leaderboards',
        'tahfiz.study_groups': 'Study Groups',
        'tahfiz.challenges': 'Challenges',
        'tahfiz.streak_champions': 'Streak Champions',
        'tahfiz.accuracy_kings': 'Accuracy Kings',
        'tahfiz.school_circles': 'School Study Circles',
        'tahfiz.new_circle': 'New Circle',
        'tahfiz.members': 'Members',
        'tahfiz.joined': 'Joined',
        'tahfiz.join': 'Join',
        'tahfiz.create_circle': 'Create a Memorization Circle',
        'tahfiz.circle_name': 'Circle Name',
        'tahfiz.circle_desc': 'Description',
        'tahfiz.circle_type': 'Circle Type',
        'tahfiz.study_circle': '📖 Regular study circle',
        'tahfiz.challenge_circle': '🏆 Active Challenge circle',
        'tahfiz.create': 'Create',
        'tahfiz.no_data': 'No data yet.',
        'tahfiz.no_submissions': 'No submissions yet.',
        'tahfiz.no_students': 'No students assigned yet.',
        'tahfiz.no_tasks': 'No tasks assigned yet.',
        'tahfiz.search_student': 'Search student…',
        'tahfiz.search_students': 'Search students by name...',
        'tahfiz.all_instructors': 'All Instructors',
        'tahfiz.in_progress': 'In Progress',
        'tahfiz.not_started': 'Not Started',
        'tahfiz.student': 'Student',
        'tahfiz.surah': 'Surah',
        'tahfiz.from_ayah': 'From Ayah',
        'tahfiz.to_ayah': 'To Ayah',
        'tahfiz.deadline': 'Deadline (optional)',
        'tahfiz.instructions': 'Instructions / Notes',
        'tahfiz.grade': 'Grade',
        'tahfiz.feedback_placeholder': 'Provide specific feedback on Tajweed, Makharij, or memorization…',
        'tahfiz.session_history': 'Session History',
        'tahfiz.your_statistics': 'Your Statistics',
        'tahfiz.tasks_from_teacher': 'Tasks from your Teacher',
        'tahfiz.quran_completion': 'Quran Completion',
        'tahfiz.assign_task_btn': 'Assign Task',
        'tahfiz.new_goal': 'New Goal',
        'tahfiz.search_surah': 'Search Surah...',
        'tahfiz.search_quran': 'Search Quran...',
        'tahfiz.mutqin': 'Mutqin',
        'tahfiz.strong': 'Strong',
        'tahfiz.needs_revision': 'Needs Revision',
        'tahfiz.my_memorization_goals': 'My Memorization Goals',
        'tahfiz.active_tasks': 'Active Tasks',
        'tahfiz.completed_reviewed': 'Completed & Reviewed',
        'tahfiz.mark_started': 'Mark as Started',
        'tahfiz.record_submit': 'Record & Submit',
        'tahfiz.recitation_submitted': 'Recitation Submitted',
        'tahfiz.awaiting_feedback': "Awaiting teacher's feedback",
        'tahfiz.previous_feedback': 'Previous Feedback',
        'tahfiz.rerecord_resubmit': 'Re-record & Resubmit',
        'tahfiz.reviewed_by_teacher': 'Reviewed by teacher',
        'tahfiz.view_report': 'View Report',
        'tahfiz.collapse': 'Collapse',
        'tahfiz.score': 'Score',
        'tahfiz.no_ai_analysis': 'AI analysis was not run for this review — ask your teacher to re-assess with AI feedback enabled.',
        'tahfiz.mistakes_noted': 'Mistake(s) Noted',
        'tahfiz.recorded_by_teacher': 'Recorded by your teacher',
        'tahfiz.round': 'Round',
        'tahfiz.your_recording': 'Your recording',
        'tahfiz.teacher_audio': 'Teacher audio',
        'tahfiz.no_sessions': 'No sessions recorded yet. Start by recording a recitation!',
        'tahfiz.assignments_from_teacher': 'Assignments from your Tahfiz teacher',
        'tahfiz.no_tasks_desc': 'Your teacher will assign memorisation tasks here.',
        'tahfiz.no_active_goals': 'No active goals yet.',
        'tahfiz.set_to_start': 'Set one to get started!',
        'tahfiz.no_sessions_short': 'No sessions recorded yet.',
        'tahfiz.earn_badges': 'Earn badges by',
        'tahfiz.maintain_streaks': 'maintaining streaks & completing goals!',
        'tahfiz.updating': 'Updating…',
        'tahfiz.select_teacher_placeholder': 'Select a teacher...',
        'tahfiz.days_left': 'days left',
        'tahfiz.days_remaining': 'days remaining',
        'tahfiz.pace': 'Pace',

        // ── Musabaqa ────────────────────────────────────────────────
        'musabaqa.title': 'Digital Musabaqa',
        'musabaqa.subtitle': 'Quran Recitation Competition',
        'musabaqa.my_competitions': 'My Competitions',
        'musabaqa.create_new': '+ Create New Competition',
        'musabaqa.resume': 'Resume',
        'musabaqa.tab_setup': 'Setup',
        'musabaqa.tab_judges': 'Judges',
        'musabaqa.tab_draw': 'Draw',
        'musabaqa.tab_live': 'Live',
        'musabaqa.tab_results': 'Results',
        'musabaqa.comp_name': 'Competition Name',
        'musabaqa.class': 'Class',
        'musabaqa.date': 'Date',
        'musabaqa.select_participants': 'Select Participants',
        'musabaqa.deck_manager': 'Challenge Card Deck',
        'musabaqa.regenerate_deck': 'Regenerate Deck',
        'musabaqa.scoring': 'Scoring (100 pts)',
        'musabaqa.create_btn': 'Create Competition & Assign Cards',
        'musabaqa.creating': 'Creating…',
        'musabaqa.judge_panel': 'Judge Panel',
        'musabaqa.judge_panel_desc': 'Invite internal staff or external judges — each gets a unique access link',
        'musabaqa.internal_staff': '🏫 Internal Staff',
        'musabaqa.external': '🌐 External',
        'musabaqa.panel_members': 'Panel Members',
        'musabaqa.add_judge': 'Add Judge',
        'musabaqa.add_external': 'Add External Judge',
        'musabaqa.added': 'Added',
        'musabaqa.audience': 'Audience / Display Screen',
        'musabaqa.audience_desc': 'Share with parents or project on screen — live leaderboard only, no scoring.',
        'musabaqa.read_only': 'Read-only',
        'musabaqa.send_email': '✉️ Send Email',
        'musabaqa.whatsapp': '📱 WhatsApp',
        'musabaqa.copy': 'Copy',
        'musabaqa.copied': '✓ Copied',
        'musabaqa.assign_cards': 'Assign Challenge Cards',
        'musabaqa.assign_cards_desc': 'Select a participant and a face-down card. Click "Assign" to draw it for them.',
        'musabaqa.participant_tap': 'Participant — tap to select, assign up to 4 cards each',
        'musabaqa.assign_btn': 'Assign',
        'musabaqa.start_live': '🚀 Start Live Competition',
        'musabaqa.assigned_cards': 'Assigned Cards',
        'musabaqa.now_reciting': 'Now Reciting',
        'musabaqa.competition_complete': 'Competition Complete!',
        'musabaqa.view_results': 'View Final Results →',
        'musabaqa.participant_queue': 'Participant Queue',
        'musabaqa.on_air': 'ON AIR',
        'musabaqa.done': '✓ Done',
        'musabaqa.call_next': '→ Call Next',
        'musabaqa.call_up': 'Call Up',
        'musabaqa.score_btn': 'Score',
        'musabaqa.mistake': 'MISTAKE',
        'musabaqa.change': 'CHANGE',
        'musabaqa.end': 'END',
        'musabaqa.new_card': 'New card',
        'musabaqa.send_recording': 'Send recording',
        'musabaqa.panel_judges': 'Panel Judges',
        'musabaqa.reveal_scores': 'Reveal Scores',
        'musabaqa.panel_consensus': 'Panel Consensus',
        'musabaqa.scoring_panel_title': 'Scoring',
        'musabaqa.notes': 'Notes',
        'musabaqa.notes_placeholder': 'e.g. Excellent tajweed, needs work on Makharij of ق…',
        'musabaqa.generate_ai': 'Generate AI Report & Save',
        'musabaqa.generating': 'Generating AI Report…',
        'musabaqa.champion': 'Musabaqa Champion',
        'musabaqa.full_results': 'Full Results & Reports',
        'musabaqa.download_pdf': 'Download Official PDF Report',
        'musabaqa.print_results': 'Print / Export Results',
        'musabaqa.ai_report': 'AI Report',
        'musabaqa.connecting': 'Connecting to competition…',
        'musabaqa.invalid_link': 'Invalid Link',
        'musabaqa.invalid_link_desc': 'This judge link is invalid or the competition has ended. Contact the competition organiser to receive a new link.',
        'musabaqa.session_ended': 'Session Ended',
        'musabaqa.session_ended_teacher': 'The teacher has ended this Musabaqa session.',
        'musabaqa.lobby_waiting': 'Competition Loading…',
        'musabaqa.lobby_desc': "The organiser is setting up the competition. You'll be notified when it begins.",
        'musabaqa.score_reveal': 'Score Reveal',
        'musabaqa.judge_signals': 'Judge Signals',
        'musabaqa.mistake_signal': 'Mistake',
        'musabaqa.change_signal': 'Change',
        'musabaqa.end_signal': 'End',
        'musabaqa.submit_scores': 'Submit Scores ✓',
        'musabaqa.submitting_scores': 'Submitting…',
        'musabaqa.scores_submitted': 'Scores Submitted!',
        'musabaqa.waiting_reveal': 'Waiting for the Head Judge to reveal scores…',
        'musabaqa.waiting_participant': 'Waiting for next participant…',
        'musabaqa.live_leaderboard': 'Live Leaderboard',
        'musabaqa.final_rankings': 'Final Rankings',
        'musabaqa.session_done': 'Session done',
        'musabaqa.session_ended_awaiting': '✓ Session ended — awaiting student to submit recording',
        'musabaqa.judge_notes_placeholder': 'Optional notes for this recitation…',
        'musabaqa.no_results': 'No results yet',
        'musabaqa.tajweed': 'Tajweed',
        'musabaqa.makharij': 'Makharij',
        'musabaqa.tarteel': 'Tarteel',
        'musabaqa.hifz': 'Hifz',
        'musabaqa.tajweed_desc': 'Tajweed rules',
        'musabaqa.makharij_desc': 'Letter articulation',
        'musabaqa.tarteel_desc': 'Flow & beauty',
        'musabaqa.hifz_desc': 'Memorisation',
        'musabaqa.no_active': 'No Active Competition',
        'musabaqa.no_active_desc': 'There is no active Musabaqa competition running for your school right now.',
        'musabaqa.go_back': 'Go Back',
        'musabaqa.final_leaderboard': 'Final Leaderboard',
        'musabaqa.your_scores': 'Your Scores',
        'musabaqa.total_score': 'Total Score',
        'musabaqa.comp_lobby': 'Competition Lobby',
        'musabaqa.card_draw': 'Card Draw Phase',
        'musabaqa.waiting_begin': 'Waiting for the teacher to begin the competition...',
        'musabaqa.cards_drawn': 'Cards are being drawn. You will be called shortly.',
        'musabaqa.your_turn': 'It is Your Turn',
        'musabaqa.begin_recitation': 'Begin Recitation',
        'musabaqa.three_mistakes': '3 Mistakes',
        'musabaqa.listen_carefully': 'Listen Carefully',
        'musabaqa.mistake_noted': 'Mistake Noted',
        'musabaqa.tap_to_start': 'Tap to Start Reciting',
        'musabaqa.stop_submit': 'Stop Recording & Submit',
        'musabaqa.uploading': 'Uploading...',
        'musabaqa.upload_recording': 'Upload Recording',
        'musabaqa.recording_submitted': 'Recording Submitted!',
        'musabaqa.your_status': 'Your Status',
        'musabaqa.your_card': 'Your Assigned Card',
        'musabaqa.all_participants': 'All Participants',
        'musabaqa.comp_in_progress': 'Competition in Progress',
        'musabaqa.submitted_recording': 'Submitted Recording',
        'musabaqa.bronze': 'Bronze',
        'musabaqa.silver': 'Silver',
        'musabaqa.gold': 'Gold',
        'musabaqa.diamond': 'Diamond',
        'musabaqa.session_code': 'Session Code',
        'musabaqa.participants': 'participants',
        'musabaqa.cancel': 'Cancel',
        'musabaqa.delete': 'Delete',
        'musabaqa.competition_setup': 'Competition Setup',
        'musabaqa.head_judge': 'HEAD JUDGE',
        'musabaqa.panel_judge': 'PANEL JUDGE',
        'musabaqa.observer': 'OBSERVER',
        'musabaqa.welcome': 'Welcome',
        'musabaqa.final': 'FINAL',
        'musabaqa.live': 'LIVE',
    },
    ar: {
        'app.title': 'بوابة KCA',
        'common.welcome': 'أهلاً بك',
        'common.login': 'تسجيل الدخول',
        'common.logout': 'تسجيل الخروج',
        'common.dashboard': 'لوحة التحكم',
        'common.back': 'عودة',
        'common.submit': 'إرسال',
        'common.cancel': 'إلغاء',
        'common.save': 'حفظ',
        'common.delete': 'حذف',
        'common.edit': 'تعديل',
        'common.view': 'عرض',
        'common.loading': 'جاري التحميل...',
        'common.error': 'خطأ',
        'common.success': 'نجاح',
        'common.report': 'تقرير',
        'common.download_pdf': 'تحميل PDF',
        'common.term': 'الفصل',
        'common.session': 'العام الدراسي',

        // Dashboard
        'dashboard.title': 'لوحة تحكم الطالب',
        'dashboard.latest_term_average': 'متوسط آخر فصل دراسي',
        'dashboard.attendance_rate': 'معدل الحضور',
        'dashboard.fees_status': 'حالة الرسوم',
        'dashboard.outstanding': 'مستحق',
        'dashboard.academic_performance_trend': 'اتجاه الأداء الأكاديمي',
        'dashboard.announcements': 'الإعلانات',
        'dashboard.recent_results': 'النتائج الأخيرة',
        'dashboard.view_all_grades': 'عرض جميع الدرجات',
        'dashboard.more_subjects': 'مواد إضافية',

        // Live Classes
        'live_classes.title': 'الفصول الافتراضية',
        'live_classes.join_class_now': 'انضم للفصل الآن',
        'live_classes.live': 'مباشر',
        'live_classes.no_active_sessions': 'لا توجد جلسات نشطة حالياً.',
        'live_classes.no_live_classes': 'لا توجد فصول افتراضية مجدولة.',
        'live_classes.started': 'بدأ',

        // Feedback
        'feedback.title': 'ملاحظات الطلاب',
        'feedback.subject': 'الموضوع',
        'feedback.type': 'النوع',
        'feedback.submit_feedback': 'إرسال الملاحظات',
        'feedback.no_feedback_submitted': 'لم يتم تقديم أي ملاحظات بعد.',
        'feedback.general_feedback': 'ملاحظات عامة',
        'feedback.complaint': 'شكوى',
        'feedback.appeal': 'استئناف',
        'feedback.appreciation': 'تقدير',
        'feedback.admin_response': 'رد الإدارة',
        'feedback.new_feedback': 'ملاحظة جديدة',
        'feedback.brief_subject': 'موضوع مختصر',
        'feedback.describe_feedback': 'صف ملاحظتك...',

        // Finance
        'finance.title': 'ماليتي',
        'finance.balance': 'الرصيد',
        'finance.status': 'الحالة',
        'finance.invoices': 'الفواتير',
        'finance.payment_history': 'سجل المدفوعات',
        'finance.no_payment_history': 'لا يوجد سجل مدفوعات.',
        'finance.account_name': 'اسم الحساب',
        'finance.account_number': 'رقم الحساب',
        'finance.bank_name': 'اسم البنك',
        'finance.total': 'المجموع',
        'finance.paid': 'المدفوع',
        'finance.action': 'إجراء',
        'finance.upload_proof': 'رفع إثبات الدفع',
        'finance.pending_verification': 'قيد التحقق',
        'finance.school_account_details': 'تفاصيل حساب المدرسة',

        // Profile
        'profile.title': 'ملفي الشخصي',
        'profile.student_information': 'معلومات الطالب',
        'profile.admission_date': 'تاريخ القبول',
        'profile.date_of_birth': 'تاريخ الميلاد',
        'profile.gender': 'الجنس',
        'profile.address': 'العنوان',

        // Portals
        'portal.admin': 'بوابة الإدارة',
        'portal.teacher': 'بوابة المعلم',
        'portal.student': 'بوابة الطالب',
        'portal.parent': 'بوابة ولي الأمر',

        // Auth
        'auth.email': 'البريد الإلكتروني',
        'auth.password': 'كلمة المرور',
        'auth.signIn': 'تسجيل الدخول',
        'auth.staffLogin': 'تسجيل دخول الموظفين',
        'auth.forgotPassword': 'نسيت كلمة المرور؟',

        // Navigation
        'nav.home': 'الرئيسية',
        'nav.dashboard': 'لوحة التحكم',
        'nav.students': 'الطلاب',
        'nav.teachers': 'المعلمين',
        'nav.classes': 'الفصول',
        'nav.sections': 'الأقسام',
        'nav.reviews': 'مراجعة الدرجات',
        'nav.attendance_logs': 'سجلات الحضور',
        'nav.iqa_reviews': 'مراجعات الجودة',
        'nav.cbt_manager': 'إدارة الاختبارات',
        'nav.timetable': 'الجدول الدراسي',
        'nav.live_classes': 'الفصل الافتراضي',
        'nav.announcements': 'الإعلانات',
        'nav.financial_management': 'الإدارة المالية',
        'nav.operations': 'مركز العمليات',
        'nav.staff_development': 'الملاحظات',
        'nav.iqa': 'ضمان الجودة',
        'nav.student_feedback': 'ملاحظات الطلاب',
        'nav.analytics': 'التحليلات',
        'nav.archives': 'الأرشيف',
        'nav.cbt_hub': 'مركز الاختبارات',
        'nav.eqa_audit': 'تدقيق الجودة',
        'nav.settings': 'الإعدادات',
        'nav.gradebook': 'سجل الدرجات',
        'nav.iqa_forms': 'نماذج الجودة',
        'nav.attendance': 'الحضور',
        'nav.finance': 'ماليتي',
        'nav.development': 'تطويري',
        'nav.profile': 'ملفي الشخصي',
        'nav.observations': 'الملاحظات',
        'nav.academics': 'الشؤون الأكاديمية',
        'nav.ai_tutor': 'المعلم الذكي',
        'nav.report_card': 'بطاقة التقرير',
        'nav.cbt_exams': 'اختبارات CBT',
        'nav.my_timetable': 'جدولي الدراسي',
        'nav.feedback': 'الملاحظات',
        'nav.theme': 'المظهر',

        // Academics
        'academics.title': 'الشؤون الأكاديمية',
        'academics.subject': 'المادة',
        'academics.ca': 'أعمال السنة',
        'academics.exam': 'الامتحان',
        'academics.total': 'المجموع',
        'academics.grade': 'الدرجة',
        'academics.remark': 'الملاحظة',
        'academics.download_report_card': 'تحميل بطاقة التقرير',

        // Exams
        'exams.title': 'اختبارات CBT',
        'exams.no_exams_scheduled': 'لا توجد اختبارات مجدولة في الوقت الحالي.',
        'exams.mins': 'دقيقة',
        'exams.start_exam': 'بدء الاختبار',

        // Extended nav — Admin
        'nav.scholarships': 'المنح الدراسية',
        'nav.messages': 'الرسائل',
        'nav.cbt_center': 'مركز الاختبارات',
        'nav.cambridge_exams': 'امتحانات كامبريدج',
        'nav.cambridge_primary': 'معلم كامبريدج الابتدائي',
        'nav.curriculum': 'المناهج الدراسية',
        'nav.tahfiz': 'تحفيظ القرآن',
        'nav.sampling_plan': 'خطة أخذ العينات',
        'nav.standardization': 'التوحيد القياسي',
        'nav.feedback_student': 'آراء الطلاب',
        'nav.feedback_teacher': 'آراء المعلمين',
        'nav.iqa_handbook': 'الدليل الرقمي',
        'nav.teacher_performance': 'أداء المعلمين',
        'nav.admissions': 'القبول والتسجيل',
        'nav.staff_attendance': 'حضور الموظفين',
        'nav.admins': 'المسؤولون',
        'nav.logout': 'تسجيل الخروج',

        // Extended nav — Teacher
        'nav.teach': 'التدريس',
        'nav.musabaqa': 'مسابقة',
        'nav.games': 'ألعاب الفصل',
        'nav.aicpd': 'دورات التطوير المهني',
        'nav.lms': 'مدرب LMS',
        'nav.external_students': 'الطلاب الخارجيون',
        'nav.handbook': 'الدليل',

        // Curriculum sub-items
        'nav.curr_early_years': 'مرحلة الطفولة المبكرة',
        'nav.curr_primary': 'المرحلة الابتدائية',
        'nav.curr_islamiyya_early': 'الروضة — المرحلة المبكرة',
        'nav.curr_islamiyya': 'الابتدائي — وزارة التعليم السعودية',
        'nav.curr_tahfiz': 'تحفيظ القرآن — IQA',
        'nav.assign_curriculum': 'تعيين المنهج',

        // Observations sub
        'nav.obs_dashboard': 'لوحة التحكم',

        // ── Tahfiz ──────────────────────────────────────────────────
        'tahfiz.hub_title': 'مركز تقييم التحفيظ',
        'tahfiz.teacher_portal_subtitle': 'بوابة المعلم · مراجعة التلاوة',
        'tahfiz.awaiting_review': 'في انتظار المراجعة',
        'tahfiz.all_caught_up': 'تمت جميع المراجعات',
        'tahfiz.all_grades': 'جميع الصفوف',
        'tahfiz.students_enrolled': 'الطلاب المسجلون',
        'tahfiz.avg_hizb': 'متوسط الحزب المكتمل',
        'tahfiz.total_hizb': 'إجمالي الأحزاب (المدرسة)',
        'tahfiz.completion_rate': 'معدل الإتمام',
        'tahfiz.total': 'الإجمالي',
        'tahfiz.graded': 'تم التقييم',
        'tahfiz.pending': 'قيد الانتظار',
        'tahfiz.class_filter': 'تصفية الفصل',
        'tahfiz.filter_desc': 'تصفية الطلاب والمهام والتسليمات حسب الفصل',
        'tahfiz.all_classes': 'جميع الفصول (عرض الكل)',
        'tahfiz.tab_submissions': 'التسليمات',
        'tahfiz.tab_assign': 'تعيين المهام',
        'tahfiz.tab_progress': 'التقدم',
        'tahfiz.tab_curriculum': 'المنهج',
        'tahfiz.tab_analytics': 'التحليلات',
        'tahfiz.tab_quran': 'قارئ القرآن',
        'tahfiz.tab_overview': 'نظرة عامة',
        'tahfiz.tab_goals': 'أهدافي',
        'tahfiz.tab_tasks': 'مهامي',
        'tahfiz.tab_record': 'تسجيل',
        'tahfiz.tab_sessions': 'الجلسات',
        'tahfiz.tab_achievements': 'الإنجازات',
        'tahfiz.tab_community': 'المجتمع',
        'tahfiz.status_pending': 'قيد الانتظار',
        'tahfiz.status_in_progress': 'جارٍ',
        'tahfiz.status_submitted': 'مُسلَّم',
        'tahfiz.status_reviewed': 'تمت المراجعة',
        'tahfiz.status_overdue': 'متأخر',
        'tahfiz.grade_excellent': 'ممتاز (أ) — متقن',
        'tahfiz.grade_good': 'جيد (ب) — راسخ',
        'tahfiz.grade_needs_revision': 'يحتاج مراجعة (ج)',
        'tahfiz.grade_ungraded': 'غير مقيَّم',
        'tahfiz.tajweed': 'التجويد',
        'tahfiz.makharij': 'المخارج',
        'tahfiz.hifdh': 'الحفظ',
        'tahfiz.fluency': 'الطلاقة',
        'tahfiz.riwayah': 'الرواية',
        'tahfiz.tarteel': 'الترتيل',
        'tahfiz.assign_task': 'تعيين مهمة',
        'tahfiz.run_analysis': 'تشغيل تحليل الشيخ',
        'tahfiz.analysing': 'جارٍ التحليل…',
        'tahfiz.submit_review': 'إرسال المراجعة',
        'tahfiz.save_changes': 'حفظ التغييرات',
        'tahfiz.cancel': 'إلغاء',
        'tahfiz.done': 'تم',
        'tahfiz.record_new': 'تسجيل جديد',
        'tahfiz.stop': 'إيقاف',
        'tahfiz.re_record': 'إعادة التسجيل',
        'tahfiz.record_correction': 'تسجيل التصحيح',
        'tahfiz.discard_recording': '✕ تجاهل وإعادة التسجيل',
        'tahfiz.open_full_review': 'فتح المراجعة الكاملة',
        'tahfiz.review_title': 'مراجعة',
        'tahfiz.student_recording': 'تسجيل الطالب',
        'tahfiz.sheikh_analysis': 'تحليل الشيخ',
        'tahfiz.sheikh_analysis_en': 'تحليل الشيخ — إنجليزي',
        'tahfiz.sheikh_analysis_ar': 'تحليل الشيخ — عربي',
        'tahfiz.your_grade': 'تقييمك',
        'tahfiz.written_feedback': 'ملاحظات مكتوبة',
        'tahfiz.audio_correction': 'تصحيح صوتي',
        'tahfiz.assign_task_title': 'تعيين مهمة حفظ',
        'tahfiz.task_monitor': 'متابعة المهام',
        'tahfiz.submission_history': 'سجل التسليمات',
        'tahfiz.corrections': 'التصحيحات',
        'tahfiz.strengths': 'نقاط القوة',
        'tahfiz.areas_to_improve': 'مجالات التحسين',
        'tahfiz.teacher_notes': 'ملاحظات المعلم',
        'tahfiz.audio_feedback': 'ملاحظات صوتية',
        'tahfiz.admin_title': 'إدارة التحفيظ',
        'tahfiz.admin_subtitle': 'المدرسة بأكملها · تحليلات حفظ القرآن',
        'tahfiz.live_dashboard': 'لوحة التحكم المباشرة',
        'tahfiz.active_students': 'الطلاب النشطون',
        'tahfiz.verses_memorized': 'الآيات المحفوظة',
        'tahfiz.avg_streak': 'متوسط الاتساق',
        'tahfiz.avg_accuracy': 'متوسط الدقة',
        'tahfiz.pending_reviews': 'المراجعات المعلقة',
        'tahfiz.perf_summary': 'ملخص الأداء',
        'tahfiz.teacher_activity': 'نشاط المعلم',
        'tahfiz.student_rosters': 'قوائم الطلاب',
        'tahfiz.community_groups': 'المجموعات المجتمعية',
        'tahfiz.juz_progress_map': 'خريطة تقدم الأجزاء على مستوى المدرسة',
        'tahfiz.students_completed_juz': 'الطلاب الذين أتمّوا كل جزء',
        'tahfiz.live_activity': 'تغذية الأنشطة المباشرة',
        'tahfiz.leaderboard': 'نخبة التحفيظ — قائمة شرف المدرسة',
        'tahfiz.top_verses': 'أكثر الآيات حفظاً',
        'tahfiz.streak_champs': 'أبطال الاتساق',
        'tahfiz.instructor_name': 'اسم المعلم',
        'tahfiz.students_assigned': 'الطلاب المعينون',
        'tahfiz.submissions_received': 'التسليمات المستلمة',
        'tahfiz.graded_reviews': 'المراجعات المُقيَّمة',
        'tahfiz.pending_queue': 'قائمة انتظار المراجعة',
        'tahfiz.avg_student_accuracy': 'متوسط دقة الطالب',
        'tahfiz.student_name': 'اسم الطالب',
        'tahfiz.grade_level': 'المستوى الدراسي',
        'tahfiz.instructor': 'المعلم',
        'tahfiz.current_juz': 'الجزء الحالي',
        'tahfiz.accuracy': 'الدقة',
        'tahfiz.active_streak': 'الاتساق النشط',
        'tahfiz.status': 'الحالة',
        'tahfiz.day_streak': 'أيام متواصلة',
        'tahfiz.full_quran': 'القرآن الكريم',
        'tahfiz.loading': 'جارٍ تحميل لوحة التحفيظ...',
        'tahfiz.verses': 'الآيات',
        'tahfiz.juz_done': 'الأجزاء المنجزة',
        'tahfiz.pages': 'الصفحات',
        'tahfiz.active_goals': 'الأهداف النشطة',
        'tahfiz.juz_map': 'خريطة حفظ الأجزاء',
        'tahfiz.recent_sessions': 'الجلسات الأخيرة',
        'tahfiz.badges': 'الشارات',
        'tahfiz.set_new_goal': 'تحديد هدف تحفيظ جديد',
        'tahfiz.goal_type': 'نوع الهدف',
        'tahfiz.new_memorization': '📖 حفظ جديد',
        'tahfiz.muraja': "🔄 مراجعة",
        'tahfiz.target_days': 'عدد الأيام المستهدفة',
        'tahfiz.daily_pace': 'الوتيرة اليومية',
        'tahfiz.create_goal': 'إنشاء هدف',
        'tahfiz.no_goals': 'لم يتم تحديد أهداف بعد. أنشئ أول هدف للحفظ!',
        'tahfiz.completed': 'مكتمل',
        'tahfiz.recitation_studio': 'استوديو التلاوة',
        'tahfiz.record_ai_grade': 'سجِّل وقيِّم بالذكاء الاصطناعي وأرسل إلى معلمك',
        'tahfiz.recording_for_task': 'التسجيل للمهمة المعيَّنة',
        'tahfiz.tap_to_record': 'اضغط لبدء التسجيل',
        'tahfiz.recording_in_progress': '● التسجيل جارٍ...',
        'tahfiz.select_teacher': 'اختر معلماً',
        'tahfiz.submitting': 'جارٍ الإرسال...',
        'tahfiz.submit_to_teacher': 'إرسال إلى المعلم',
        'tahfiz.submitted_ok': 'تم الإرسال بنجاح!',
        'tahfiz.submitted_desc': 'سيراجع معلمك التسجيل ويزودك بالتغذية الراجعة قريباً.',
        'tahfiz.record_another': 'تسجيل آخر',
        'tahfiz.total_sessions': 'إجمالي الجلسات',
        'tahfiz.hours_invested': 'ساعات الدراسة',
        'tahfiz.current_streak': 'الاتساق الحالي',
        'tahfiz.longest_streak': 'أطول اتساق',
        'tahfiz.pages_memorized': 'الصفحات المحفوظة',
        'tahfiz.pages_reviewed': 'الصفحات المراجعة',
        'tahfiz.badges_earned': 'الشارات المكتسبة',
        'tahfiz.no_badges': 'لا توجد شارات بعد',
        'tahfiz.keep_practicing': 'واصل التدريب لتحصل على أول شارة!',
        'tahfiz.community_title': 'المجتمع ولوحات الشرف',
        'tahfiz.community_subtitle': 'حلقات التحفيظ · التحديات · الترتيب',
        'tahfiz.leaderboards': 'لوحات الشرف',
        'tahfiz.study_groups': 'مجموعات الدراسة',
        'tahfiz.challenges': 'التحديات',
        'tahfiz.streak_champions': 'أبطال الاتساق',
        'tahfiz.accuracy_kings': 'أبطال الدقة',
        'tahfiz.school_circles': 'حلقات الدراسة المدرسية',
        'tahfiz.new_circle': 'حلقة جديدة',
        'tahfiz.members': 'الأعضاء',
        'tahfiz.joined': 'مشترك',
        'tahfiz.join': 'انضمام',
        'tahfiz.create_circle': 'إنشاء حلقة حفظ',
        'tahfiz.circle_name': 'اسم الحلقة',
        'tahfiz.circle_desc': 'الوصف',
        'tahfiz.circle_type': 'نوع الحلقة',
        'tahfiz.study_circle': '📖 حلقة دراسة عادية',
        'tahfiz.challenge_circle': '🏆 حلقة تحدٍّ نشطة',
        'tahfiz.create': 'إنشاء',
        'tahfiz.no_data': 'لا توجد بيانات بعد.',
        'tahfiz.no_submissions': 'لا توجد تسليمات بعد.',
        'tahfiz.no_students': 'لم يتم تعيين طلاب بعد.',
        'tahfiz.no_tasks': 'لم يتم تعيين مهام بعد.',
        'tahfiz.search_student': 'ابحث عن طالب…',
        'tahfiz.search_students': 'ابحث عن طلاب بالاسم...',
        'tahfiz.all_instructors': 'جميع المعلمين',
        'tahfiz.in_progress': 'جارٍ',
        'tahfiz.not_started': 'لم يبدأ',
        'tahfiz.student': 'الطالب',
        'tahfiz.surah': 'السورة',
        'tahfiz.from_ayah': 'من الآية',
        'tahfiz.to_ayah': 'إلى الآية',
        'tahfiz.deadline': 'الموعد النهائي (اختياري)',
        'tahfiz.instructions': 'تعليمات / ملاحظات',
        'tahfiz.grade': 'التقييم',
        'tahfiz.feedback_placeholder': 'أضف ملاحظاتك حول التجويد والمخارج أو الحفظ…',
        'tahfiz.session_history': 'سجل الجلسات',
        'tahfiz.your_statistics': 'إحصائياتك',
        'tahfiz.tasks_from_teacher': 'مهام من معلمك',
        'tahfiz.quran_completion': 'إتمام القرآن',
        'tahfiz.assign_task_btn': 'تعيين مهمة',
        'tahfiz.new_goal': 'هدف جديد',
        'tahfiz.search_surah': 'ابحث عن سورة...',
        'tahfiz.search_quran': 'ابحث في القرآن...',
        'tahfiz.mutqin': 'متقن',
        'tahfiz.strong': 'قوي',
        'tahfiz.needs_revision': 'يحتاج مراجعة',
        'tahfiz.my_memorization_goals': 'أهدافي في الحفظ',
        'tahfiz.active_tasks': 'المهام النشطة',
        'tahfiz.completed_reviewed': 'مكتمل ومراجَع',
        'tahfiz.mark_started': 'ابدأ',
        'tahfiz.record_submit': 'سجِّل وأرسل',
        'tahfiz.recitation_submitted': 'تم إرسال التلاوة',
        'tahfiz.awaiting_feedback': 'في انتظار ملاحظات المعلم',
        'tahfiz.previous_feedback': 'الملاحظات السابقة',
        'tahfiz.rerecord_resubmit': 'أعِد التسجيل والإرسال',
        'tahfiz.reviewed_by_teacher': 'تمت المراجعة من قِبَل المعلم',
        'tahfiz.view_report': 'عرض التقرير',
        'tahfiz.collapse': 'طيّ',
        'tahfiz.score': 'النتيجة',
        'tahfiz.no_ai_analysis': 'لم يتم إجراء تحليل الذكاء الاصطناعي لهذه المراجعة — اطلب من معلمك إعادة التقييم مع تفعيل ملاحظات الذكاء الاصطناعي.',
        'tahfiz.mistakes_noted': 'أخطاء مُلاحظة',
        'tahfiz.recorded_by_teacher': 'مسجَّل من قِبَل المعلم',
        'tahfiz.round': 'الجولة',
        'tahfiz.your_recording': 'تسجيلك',
        'tahfiz.teacher_audio': 'صوت المعلم',
        'tahfiz.no_sessions': 'لم يتم تسجيل أي جلسة بعد. ابدأ بتسجيل تلاوة!',
        'tahfiz.assignments_from_teacher': 'المهام من معلم التحفيظ',
        'tahfiz.no_tasks_desc': 'سيحدد معلمك مهام الحفظ هنا.',
        'tahfiz.no_active_goals': 'لا أهداف نشطة بعد.',
        'tahfiz.set_to_start': 'أنشئ هدفاً للبدء!',
        'tahfiz.no_sessions_short': 'لم يتم تسجيل أي جلسة.',
        'tahfiz.earn_badges': 'اكسب الشارات',
        'tahfiz.maintain_streaks': 'بالحفاظ على الاتساق وإنجاز الأهداف!',
        'tahfiz.updating': 'جارٍ التحديث…',
        'tahfiz.select_teacher_placeholder': 'اختر معلماً...',
        'tahfiz.days_left': 'يوم متبقٍ',
        'tahfiz.days_remaining': 'يوم متبقٍ',
        'tahfiz.pace': 'الوتيرة',

        // ── Musabaqa ────────────────────────────────────────────────
        'musabaqa.title': 'المسابقة الرقمية',
        'musabaqa.subtitle': 'مسابقة تلاوة القرآن الكريم',
        'musabaqa.my_competitions': 'مسابقاتي',
        'musabaqa.create_new': '+ إنشاء مسابقة جديدة',
        'musabaqa.resume': 'متابعة',
        'musabaqa.tab_setup': 'الإعداد',
        'musabaqa.tab_judges': 'الحكام',
        'musabaqa.tab_draw': 'السحب',
        'musabaqa.tab_live': 'مباشر',
        'musabaqa.tab_results': 'النتائج',
        'musabaqa.comp_name': 'اسم المسابقة',
        'musabaqa.class': 'الفصل',
        'musabaqa.date': 'التاريخ',
        'musabaqa.select_participants': 'اختر المشاركين',
        'musabaqa.deck_manager': 'مجموعة بطاقات التحدي',
        'musabaqa.regenerate_deck': 'إعادة توليد المجموعة',
        'musabaqa.scoring': 'التقييم (100 نقطة)',
        'musabaqa.create_btn': 'إنشاء المسابقة وتعيين البطاقات',
        'musabaqa.creating': 'جارٍ الإنشاء…',
        'musabaqa.judge_panel': 'لجنة التحكيم',
        'musabaqa.judge_panel_desc': 'ادعُ الموظفين الداخليين أو الحكام الخارجيين — يحصل كل منهم على رابط وصول فريد',
        'musabaqa.internal_staff': '🏫 موظفون داخليون',
        'musabaqa.external': '🌐 خارجي',
        'musabaqa.panel_members': 'أعضاء اللجنة',
        'musabaqa.add_judge': 'إضافة حكم',
        'musabaqa.add_external': 'إضافة حكم خارجي',
        'musabaqa.added': 'تمت الإضافة',
        'musabaqa.audience': 'الجمهور / شاشة العرض',
        'musabaqa.audience_desc': 'شارك مع أولياء الأمور أو اعرض على الشاشة — لوحة النتائج المباشرة فقط، بدون تقييم.',
        'musabaqa.read_only': 'للقراءة فقط',
        'musabaqa.send_email': '✉️ إرسال بريد إلكتروني',
        'musabaqa.whatsapp': '📱 واتساب',
        'musabaqa.copy': 'نسخ',
        'musabaqa.copied': '✓ تم النسخ',
        'musabaqa.assign_cards': 'تعيين بطاقات التحدي',
        'musabaqa.assign_cards_desc': 'اختر مشاركاً وبطاقة مقلوبة. انقر على "تعيين" لسحبها له.',
        'musabaqa.participant_tap': 'المشارك — اضغط للاختيار، عيِّن حتى 4 بطاقات لكل منهم',
        'musabaqa.assign_btn': 'تعيين',
        'musabaqa.start_live': '🚀 بدء المسابقة المباشرة',
        'musabaqa.assigned_cards': 'البطاقات المعيَّنة',
        'musabaqa.now_reciting': 'يتلو الآن',
        'musabaqa.competition_complete': 'اكتملت المسابقة!',
        'musabaqa.view_results': 'عرض النتائج النهائية ←',
        'musabaqa.participant_queue': 'قائمة المشاركين',
        'musabaqa.on_air': 'على الهواء',
        'musabaqa.done': '✓ تم',
        'musabaqa.call_next': '← استدعاء التالي',
        'musabaqa.call_up': 'استدعاء',
        'musabaqa.score_btn': 'تقييم',
        'musabaqa.mistake': 'خطأ',
        'musabaqa.change': 'تغيير',
        'musabaqa.end': 'إنهاء',
        'musabaqa.new_card': 'بطاقة جديدة',
        'musabaqa.send_recording': 'إرسال التسجيل',
        'musabaqa.panel_judges': 'هيئة الحكام',
        'musabaqa.reveal_scores': 'كشف الدرجات',
        'musabaqa.panel_consensus': 'إجماع الهيئة',
        'musabaqa.scoring_panel_title': 'التقييم',
        'musabaqa.notes': 'ملاحظات',
        'musabaqa.notes_placeholder': 'مثال: تجويد ممتاز، يحتاج تحسين في مخارج حرف ق…',
        'musabaqa.generate_ai': 'توليد تقرير ذكاء اصطناعي وحفظه',
        'musabaqa.generating': 'جارٍ توليد التقرير…',
        'musabaqa.champion': 'بطل المسابقة',
        'musabaqa.full_results': 'النتائج الكاملة والتقارير',
        'musabaqa.download_pdf': 'تنزيل التقرير الرسمي PDF',
        'musabaqa.print_results': 'طباعة / تصدير النتائج',
        'musabaqa.ai_report': 'تقرير الذكاء الاصطناعي',
        'musabaqa.connecting': 'جارٍ الاتصال بالمسابقة…',
        'musabaqa.invalid_link': 'رابط غير صالح',
        'musabaqa.invalid_link_desc': 'رابط الحكم غير صالح أو انتهت المسابقة. تواصل مع منظم المسابقة للحصول على رابط جديد.',
        'musabaqa.session_ended': 'انتهت الجلسة',
        'musabaqa.session_ended_teacher': 'أنهى المعلم جلسة المسابقة.',
        'musabaqa.lobby_waiting': 'جارٍ تحميل المسابقة…',
        'musabaqa.lobby_desc': 'يقوم المنظم بإعداد المسابقة. ستُبلَّغ عند البدء.',
        'musabaqa.score_reveal': 'كشف الدرجات',
        'musabaqa.judge_signals': 'إشارات الحكم',
        'musabaqa.mistake_signal': 'خطأ',
        'musabaqa.change_signal': 'تغيير',
        'musabaqa.end_signal': 'إنهاء',
        'musabaqa.submit_scores': 'إرسال الدرجات ✓',
        'musabaqa.submitting_scores': 'جارٍ الإرسال…',
        'musabaqa.scores_submitted': 'تم إرسال الدرجات!',
        'musabaqa.waiting_reveal': 'في انتظار رئيس الحكام لإعلان الدرجات…',
        'musabaqa.waiting_participant': 'في انتظار المشارك التالي…',
        'musabaqa.live_leaderboard': 'لوحة النتائج المباشرة',
        'musabaqa.final_rankings': 'الترتيب النهائي',
        'musabaqa.session_done': 'انتهت الجلسة',
        'musabaqa.session_ended_awaiting': '✓ انتهت الجلسة — في انتظار تسجيل الطالب',
        'musabaqa.judge_notes_placeholder': 'ملاحظات اختيارية حول هذه التلاوة…',
        'musabaqa.no_results': 'لا توجد نتائج بعد',
        'musabaqa.tajweed': 'التجويد',
        'musabaqa.makharij': 'المخارج',
        'musabaqa.tarteel': 'الترتيل',
        'musabaqa.hifz': 'الحفظ',
        'musabaqa.tajweed_desc': 'أحكام التجويد',
        'musabaqa.makharij_desc': 'مخارج الحروف',
        'musabaqa.tarteel_desc': 'الجمال والترتيل',
        'musabaqa.hifz_desc': 'الحفظ',
        'musabaqa.no_active': 'لا توجد مسابقة نشطة',
        'musabaqa.no_active_desc': 'لا توجد مسابقة تلاوة نشطة لمدرستك في الوقت الحالي.',
        'musabaqa.go_back': 'رجوع',
        'musabaqa.final_leaderboard': 'النتائج النهائية',
        'musabaqa.your_scores': 'درجاتك',
        'musabaqa.total_score': 'مجموع الدرجات',
        'musabaqa.comp_lobby': 'صالة الانتظار',
        'musabaqa.card_draw': 'مرحلة سحب البطاقات',
        'musabaqa.waiting_begin': 'في انتظار المعلم لبدء المسابقة...',
        'musabaqa.cards_drawn': 'جارٍ سحب البطاقات. ستُستدعى قريباً.',
        'musabaqa.your_turn': 'حان دورك',
        'musabaqa.begin_recitation': 'ابدأ التلاوة',
        'musabaqa.three_mistakes': '٣ أخطاء',
        'musabaqa.listen_carefully': 'استمع جيداً',
        'musabaqa.mistake_noted': 'تم تسجيل الخطأ',
        'musabaqa.tap_to_start': 'اضغط لبدء التلاوة',
        'musabaqa.stop_submit': 'إيقاف التسجيل وإرساله',
        'musabaqa.uploading': 'جارٍ الرفع...',
        'musabaqa.upload_recording': 'رفع التسجيل',
        'musabaqa.recording_submitted': 'تم إرسال التسجيل!',
        'musabaqa.your_status': 'حالتك',
        'musabaqa.your_card': 'بطاقتك المعيَّنة',
        'musabaqa.all_participants': 'جميع المشاركين',
        'musabaqa.comp_in_progress': 'المسابقة جارية',
        'musabaqa.submitted_recording': 'التسجيل المُرسَل',
        'musabaqa.bronze': 'برونزي',
        'musabaqa.silver': 'فضي',
        'musabaqa.gold': 'ذهبي',
        'musabaqa.diamond': 'ماسي',
        'musabaqa.session_code': 'رمز الجلسة',
        'musabaqa.participants': 'مشاركون',
        'musabaqa.cancel': 'إلغاء',
        'musabaqa.delete': 'حذف',
        'musabaqa.competition_setup': 'إعداد المسابقة',
        'musabaqa.head_judge': 'رئيس الحكام',
        'musabaqa.panel_judge': 'حكم اللجنة',
        'musabaqa.observer': 'مراقب',
        'musabaqa.welcome': 'أهلاً',
        'musabaqa.final': 'نهائي',
        'musabaqa.live': 'مباشر',
    },
    ha: {
        'app.title': 'KCA Portal',
        'common.welcome': 'Barka da zuwa',
        'common.login': 'Shiga',
        'common.logout': 'Fita',
        'common.dashboard': 'Dashboard',
        'common.back': 'Baya',
        'common.submit': 'Mika',
        'common.cancel': 'Soke',
        'common.save': 'Ajiye',
        'common.delete': 'Goge',
        'common.edit': 'Gyara',
        'common.view': 'Duba',
        'common.loading': 'Ana lodawa...',
        'common.error': 'Kuskure',
        'common.success': 'Nasara',
        'common.report': 'Rahoto',
        'common.download_pdf': 'Sauke PDF',
        'common.term': 'Zango',
        'common.session': 'Zama',

        // Dashboard
        'dashboard.title': 'Dashboard na Dalibai',
        'dashboard.latest_term_average': 'Matsakaicin Zango na Karshe',
        'dashboard.attendance_rate': 'Yawan Halarta',
        'dashboard.fees_status': 'Matsayin Kudade',
        'dashboard.outstanding': 'Wanda ake bi',
        'dashboard.academic_performance_trend': 'Yanayin Kokari',
        'dashboard.announcements': 'Sanarwa',
        'dashboard.recent_results': 'Sakamakon Kwanan nan',
        'dashboard.view_all_grades': 'Duba Duk Maki',
        'dashboard.more_subjects': 'karin darussa',

        // Live Classes
        'live_classes.title': 'Azuzuwan Yanar Gizo',
        'live_classes.join_class_now': 'Shiga Aji Yanzu',
        'live_classes.live': 'LIVE',
        'live_classes.no_active_sessions': 'Babu aji mai gudana a yanzu.',
        'live_classes.no_live_classes': 'Babu azuzuwan yanar gizo da aka tsara.',
        'live_classes.started': 'Ya Fara',

        // Feedback
        'feedback.title': 'Ra\'ayin Dalibai',
        'feedback.subject': 'Jigo',
        'feedback.type': 'Nau\'i',
        'feedback.submit_feedback': 'Mika Ra\'ayi',
        'feedback.no_feedback_submitted': 'Ba a mika ra\'ayi ba tukuna.',
        'feedback.general_feedback': 'Janar Ra\'ayi',
        'feedback.complaint': 'Korafi',
        'feedback.appeal': 'Daukaka Kara',
        'feedback.appreciation': 'Yabo',
        'feedback.admin_response': 'Amsar Admin',
        'feedback.new_feedback': 'Sabon Ra\'ayi',
        'feedback.brief_subject': 'Takaitaccen jigo',
        'feedback.describe_feedback': 'Bayyana ra\'ayinka...',

        // Finance
        'finance.title': 'Kudina',
        'finance.balance': 'Saura',
        'finance.status': 'Matsayi',
        'finance.invoices': 'Rasit',
        'finance.payment_history': 'Tarihin Biya',
        'finance.no_payment_history': 'Babu tarihin biya.',
        'finance.account_name': 'Sunan Asusun',
        'finance.account_number': 'Lambar Asusun',
        'finance.bank_name': 'Sunan Banki',
        'finance.total': 'Jimilla',
        'finance.paid': 'An Biya',
        'finance.action': 'Aiki',
        'finance.upload_proof': 'Loda Shaida',
        'finance.pending_verification': 'Ana Tabbatarwa',
        'finance.school_account_details': 'Bayanan Asusun Makaranta',

        // Profile
        'profile.title': 'Bayani na',
        'profile.student_information': 'Bayanan Dalibi',
        'profile.admission_date': 'Ranar Shiga',
        'profile.date_of_birth': 'Ranar Haihuwa',
        'profile.gender': 'Jinsi',
        'profile.address': 'Adireshi',

        // Portals
        'portal.admin': 'Admin Portal',
        'portal.teacher': 'Teacher Portal',
        'portal.student': 'Student Portal',
        'portal.parent': 'Parent Portal',

        // Auth
        'auth.email': 'Imel',
        'auth.password': 'Kalmar Sirri',
        'auth.signIn': 'Shiga',
        'auth.staffLogin': 'Shiga Ma\'aikata',
        'auth.forgotPassword': 'Manta Kalmar Sirri?',

        // Navigation
        'nav.home': 'Gida',
        'nav.dashboard': 'Dashboard',
        'nav.students': 'Dalibai',
        'nav.teachers': 'Malamai',
        'nav.classes': 'Azuzuwa',
        'nav.sections': 'Sashe',
        'nav.reviews': 'Duba Maki',
        'nav.attendance_logs': 'Rikodin Halarta',
        'nav.iqa_reviews': 'Duba IQA',
        'nav.cbt_manager': 'Manajan CBT',
        'nav.timetable': 'Jadawalin Lokaci',
        'nav.live_classes': 'Ajin Yanar Gizo',
        'nav.announcements': 'Sanarwa',
        'nav.financial_management': 'Gudanar da Kudi',
        'nav.operations': 'Ayyuka',
        'nav.staff_development': 'Lura',
        'nav.iqa': 'IQA',
        'nav.student_feedback': 'Ra\'ayin Dalibai',
        'nav.analytics': 'Bincike',
        'nav.archives': 'Taska',
        'nav.cbt_hub': 'CBT Hub',
        'nav.eqa_audit': 'EQA Audit',
        'nav.settings': 'Saituna',
        'nav.gradebook': 'Littafin Maki',
        'nav.iqa_forms': 'Fom na IQA',
        'nav.attendance': 'Halarta',
        'nav.finance': 'Kudina',
        'nav.development': 'Ci gaba na',
        'nav.profile': 'Bayani na',
        'nav.observations': 'Lura',
        'nav.academics': 'Karatu',
        'nav.ai_tutor': 'AI Tutor',
        'nav.report_card': 'Sakamako',
        'nav.cbt_exams': 'Jarrabawar CBT',
        'nav.my_timetable': 'Jadawali na',
        'nav.feedback': 'Ra\'ayi',
        'nav.theme': 'Jigo',

        // Academics
        'academics.title': 'Karatu',
        'academics.subject': 'Darasi',
        'academics.ca': 'CA',
        'academics.exam': 'Jarrabawa',
        'academics.total': 'Jimilla',
        'academics.grade': 'Maki',
        'academics.remark': 'Bayani',
        'academics.download_report_card': 'Sauke Sakamako',

        // Exams
        'exams.title': 'Jarrabawar CBT',
        'exams.no_exams_scheduled': 'Babu jarrabawa a yanzu.',
        'exams.mins': 'minti',
        'exams.start_exam': 'Fara Jarrabawa',

        // ── Tahfiz ──────────────────────────────────────────────────
        'tahfiz.hub_title': 'Cibiyar Kimar Hifdhi',
        'tahfiz.teacher_portal_subtitle': 'Portal na Malamai · Duba Karatu',
        'tahfiz.awaiting_review': 'Ana jiran duba',
        'tahfiz.all_caught_up': 'An kammala duka',
        'tahfiz.all_grades': 'Duk Matakai',
        'tahfiz.students_enrolled': 'Dalibai Masu Rajista',
        'tahfiz.avg_hizb': 'Matsakaicin Hizbi da aka Kammala',
        'tahfiz.total_hizb': 'Jimlar Hizbi (Makaranta)',
        'tahfiz.completion_rate': 'Ƙimar Kammalawa',
        'tahfiz.total': 'Jimla',
        'tahfiz.graded': 'An yi maki',
        'tahfiz.pending': 'Ana jira',
        'tahfiz.class_filter': 'Tace Ajin',
        'tahfiz.filter_desc': 'Tace dalibai, ayyuka, da mika aiki ta ajin',
        'tahfiz.all_classes': 'Dukan Ajin (Nuna Duka)',
        'tahfiz.tab_submissions': 'Ayyukan da aka Mika',
        'tahfiz.tab_assign': 'Ba da Ayyuka',
        'tahfiz.tab_progress': 'Ci gaba',
        'tahfiz.tab_curriculum': 'Manhaji',
        'tahfiz.tab_analytics': 'Bincike',
        'tahfiz.tab_quran': 'Karanta Alqurani',
        'tahfiz.tab_overview': 'Duba gabaɗaya',
        'tahfiz.tab_goals': 'Manufofina',
        'tahfiz.tab_tasks': 'Ayyukana',
        'tahfiz.tab_record': 'Yin Rikodin',
        'tahfiz.tab_sessions': 'Zaman Karatu',
        'tahfiz.tab_achievements': 'Nasarori',
        'tahfiz.tab_community': 'Al\'umma',
        'tahfiz.status_pending': 'Ana jira',
        'tahfiz.status_in_progress': 'Ana gudana',
        'tahfiz.status_submitted': 'An mika',
        'tahfiz.status_reviewed': 'An duba',
        'tahfiz.status_overdue': 'Ya wuce lokaci',
        'tahfiz.grade_excellent': 'Kyakkyawa (A) — Mutqin',
        'tahfiz.grade_good': 'Mai kyau (B)',
        'tahfiz.grade_needs_revision': 'Yana bukatar gyara (C)',
        'tahfiz.grade_ungraded': 'Ba a yi maki ba',
        'tahfiz.tajweed': 'Tajweed',
        'tahfiz.makharij': 'Makharij',
        'tahfiz.hifdh': 'Hifdhi',
        'tahfiz.fluency': 'Saukin Karatu',
        'tahfiz.riwayah': 'Riwayah',
        'tahfiz.tarteel': 'Tarteel',
        'tahfiz.assign_task': 'Ba da Aiki',
        'tahfiz.run_analysis': 'Gudanar da Nazari',
        'tahfiz.analysing': 'Ana nazari…',
        'tahfiz.submit_review': 'Aika Duba',
        'tahfiz.save_changes': 'Ajiye Canje-canje',
        'tahfiz.cancel': 'Soke',
        'tahfiz.done': 'An gama',
        'tahfiz.record_new': 'Sabon Rikodi',
        'tahfiz.stop': 'Tsaya',
        'tahfiz.re_record': 'Yi Rikodi Sake',
        'tahfiz.record_correction': 'Yin Rikodi na Gyara',
        'tahfiz.discard_recording': '✕ Watsar da yi sake',
        'tahfiz.open_full_review': 'Buɗe Cikakken Duba',
        'tahfiz.review_title': 'Duba',
        'tahfiz.student_recording': 'Rikodi na Dalibi',
        'tahfiz.sheikh_analysis': 'Nazarin Sheikh',
        'tahfiz.sheikh_analysis_en': 'Nazarin Sheikh — Turanci',
        'tahfiz.sheikh_analysis_ar': 'Nazarin Sheikh — Larabci',
        'tahfiz.your_grade': 'Makin da Kuka Bayar',
        'tahfiz.written_feedback': 'Sharhin Rubutu',
        'tahfiz.audio_correction': 'Gyara ta Audio',
        'tahfiz.assign_task_title': 'Ba da Aikin Haddace',
        'tahfiz.task_monitor': 'Kula da Ayyuka',
        'tahfiz.submission_history': 'Tarihin Mika Aiki',
        'tahfiz.corrections': 'Gyare-gyare',
        'tahfiz.strengths': 'Ƙarfin Karatu',
        'tahfiz.areas_to_improve': 'Wuraren da ke Buƙatar Gyara',
        'tahfiz.teacher_notes': 'Bayanan Malami',
        'tahfiz.audio_feedback': 'Sharhin Audio',
        'tahfiz.admin_title': 'Gudanar da Hifdhi',
        'tahfiz.admin_subtitle': 'Dukan Makaranta · Binciken Haddace Alqurani',
        'tahfiz.live_dashboard': 'Dashboard mai Rai',
        'tahfiz.active_students': 'Dalibai Masu Aiki',
        'tahfiz.verses_memorized': 'Ayoyin da aka Haddace',
        'tahfiz.avg_streak': 'Matsakaicin Jerin Kwanaki',
        'tahfiz.avg_accuracy': 'Matsakaicin Daidaito',
        'tahfiz.pending_reviews': 'Duba da ke Jira',
        'tahfiz.perf_summary': 'Taƙaitaccen Aiki',
        'tahfiz.teacher_activity': 'Ayyukan Malamai',
        'tahfiz.student_rosters': 'Jerin Dalibai',
        'tahfiz.community_groups': 'Ƙungiyoyin Al\'umma',
        'tahfiz.juz_progress_map': 'Taswirar Ci gaban Juzu\'i',
        'tahfiz.students_completed_juz': 'Daliban da suka kammala kowanne Juzu\'i',
        'tahfiz.live_activity': 'Ayyukan da ke gudana yanzu',
        'tahfiz.leaderboard': 'Jerin Masu Ɗaukaka — Makaranta',
        'tahfiz.top_verses': 'Mafi Yawan Ayoyin da aka Haddace',
        'tahfiz.streak_champs': 'Gasar Ci-gaba',
        'tahfiz.instructor_name': 'Sunan Malami',
        'tahfiz.students_assigned': 'Dalibai da aka Sanya',
        'tahfiz.submissions_received': 'Ayyukan da aka Karba',
        'tahfiz.graded_reviews': 'Duba da aka Yi Maki',
        'tahfiz.pending_queue': 'Jerin Duba da ke Jira',
        'tahfiz.avg_student_accuracy': 'Matsakaicin Daidaito na Dalibi',
        'tahfiz.student_name': 'Sunan Dalibi',
        'tahfiz.grade_level': 'Matakin Aji',
        'tahfiz.instructor': 'Malami',
        'tahfiz.current_juz': 'Juzu\'in da ake yanzu',
        'tahfiz.accuracy': 'Daidaito',
        'tahfiz.active_streak': 'Jerin Kwanaki',
        'tahfiz.status': 'Yanayi',
        'tahfiz.day_streak': 'Kwanaki Jere',
        'tahfiz.full_quran': 'Cikakken Alqurani',
        'tahfiz.loading': 'Ana loda Dashboard na Hifdhi...',
        'tahfiz.verses': 'Ayoyi',
        'tahfiz.juz_done': 'Juzu\'i da aka Gama',
        'tahfiz.pages': 'Shafuka',
        'tahfiz.active_goals': 'Manufofi Masu Aiki',
        'tahfiz.juz_map': 'Taswirar Haddace Juzu\'i',
        'tahfiz.recent_sessions': 'Zamana na baya-bayan nan',
        'tahfiz.badges': 'Kyaututtuka',
        'tahfiz.set_new_goal': 'Saita Sabon Manufa',
        'tahfiz.goal_type': 'Nau\'in Manufa',
        'tahfiz.new_memorization': '📖 Sabon Haddace',
        'tahfiz.muraja': "🔄 Muraaja'a (Sake Duba)",
        'tahfiz.target_days': 'Kwanaki na Manufa',
        'tahfiz.daily_pace': 'Gurin Kowanne Rana',
        'tahfiz.create_goal': 'Ƙirƙiri Manufa',
        'tahfiz.no_goals': 'Ba a saita manufa tukuna. Ƙirƙiri manufar farko!',
        'tahfiz.completed': 'An gama',
        'tahfiz.recitation_studio': 'Ɗakin Rikodin Karatu',
        'tahfiz.record_ai_grade': 'Yi rikodi, a kimanta da AI, a aika wa malami',
        'tahfiz.recording_for_task': 'Rikodi na Aikin da aka Sanya',
        'tahfiz.tap_to_record': 'Danna don fara rikodi',
        'tahfiz.recording_in_progress': '● Ana Rikodi...',
        'tahfiz.select_teacher': 'Zaɓi Malami',
        'tahfiz.submitting': 'Ana aika...',
        'tahfiz.submit_to_teacher': 'Aika wa Malami',
        'tahfiz.submitted_ok': 'An aika cikin nasara!',
        'tahfiz.submitted_desc': 'Malaminku zai duba rikodi ya ba da sharhi.',
        'tahfiz.record_another': 'Yi Wani Rikodi',
        'tahfiz.total_sessions': 'Jimlar Zamana',
        'tahfiz.hours_invested': 'Awannin Karatu',
        'tahfiz.current_streak': 'Jerin Kwanaki na Yanzu',
        'tahfiz.longest_streak': 'Dogon Jerin Kwanaki',
        'tahfiz.pages_memorized': 'Shafukan da aka Haddace',
        'tahfiz.pages_reviewed': 'Shafukan da aka Duba',
        'tahfiz.badges_earned': 'Kyaututtukan da aka Samu',
        'tahfiz.no_badges': 'Babu kyaututu tukuna',
        'tahfiz.keep_practicing': 'Ci gaba da karatun don samun kyautu na farko!',
        'tahfiz.community_title': "Al'umma da Jerin Masu Ɗaukaka",
        'tahfiz.community_subtitle': "Ƙungiyoyin Hifdhi · Gasar · Jerin",
        'tahfiz.leaderboards': "Jerin Masu Ɗaukaka",
        'tahfiz.study_groups': 'Ƙungiyoyin Karatu',
        'tahfiz.challenges': 'Gasannin',
        'tahfiz.streak_champions': 'Gasar Ci-gaba',
        'tahfiz.accuracy_kings': 'Gasar Daidaito',
        'tahfiz.school_circles': 'Ƙungiyoyin Karatu na Makaranta',
        'tahfiz.new_circle': 'Sabuwar Ƙungiya',
        'tahfiz.members': 'Mambobi',
        'tahfiz.joined': 'Ya shiga',
        'tahfiz.join': 'Shiga',
        'tahfiz.create_circle': 'Ƙirƙiri Ƙungiyar Haddace',
        'tahfiz.circle_name': 'Sunan Ƙungiya',
        'tahfiz.circle_desc': 'Bayani',
        'tahfiz.circle_type': "Nau'in Ƙungiya",
        'tahfiz.study_circle': '📖 Ƙungiyar karatu ta yau da kullum',
        'tahfiz.challenge_circle': '🏆 Ƙungiyar Gasa mai Aiki',
        'tahfiz.create': 'Ƙirƙiro',
        'tahfiz.no_data': 'Babu bayanai tukuna.',
        'tahfiz.no_submissions': 'Babu ayyukan da aka mika tukuna.',
        'tahfiz.no_students': 'Babu dalibai da aka sanya tukuna.',
        'tahfiz.no_tasks': 'Babu ayyuka da aka sanya tukuna.',
        'tahfiz.search_student': 'Nemi dalibi…',
        'tahfiz.search_students': 'Nemi dalibai da sunansu...',
        'tahfiz.all_instructors': 'Dukan Malamai',
        'tahfiz.in_progress': 'Ana gudana',
        'tahfiz.not_started': 'Ba a fara ba',
        'tahfiz.student': 'Dalibi',
        'tahfiz.surah': 'Sura',
        'tahfiz.from_ayah': 'Daga Aya',
        'tahfiz.to_ayah': 'Zuwa Aya',
        'tahfiz.deadline': 'Ranar ƙarshe (zabi)',
        'tahfiz.instructions': 'Umarni / Bayani',
        'tahfiz.grade': 'Maki',
        'tahfiz.feedback_placeholder': 'Rubuta sharhi game da Tajweed, Makharij ko haddacewa…',
        'tahfiz.session_history': 'Tarihin Zamana',
        'tahfiz.your_statistics': 'Kididdigan ka',
        'tahfiz.tasks_from_teacher': 'Ayyuka daga Malaminku',
        'tahfiz.quran_completion': 'Kammala Alqurani',
        'tahfiz.assign_task_btn': 'Ba da Aiki',
        'tahfiz.new_goal': 'Sabon Manufa',
        'tahfiz.search_surah': 'Nemi Sura...',
        'tahfiz.search_quran': 'Nemi a Alqurani...',
        'tahfiz.mutqin': 'Mutqin',
        'tahfiz.strong': 'Ƙarfi',
        'tahfiz.needs_revision': 'Yana Bukatar Gyara',
        'tahfiz.my_memorization_goals': 'Manufofina na Haddace',
        'tahfiz.active_tasks': 'Ayyuka Masu Aiki',
        'tahfiz.completed_reviewed': 'An gama kuma an bita',
        'tahfiz.mark_started': 'Fara',
        'tahfiz.record_submit': 'Yi Rikodi kuma Aika',
        'tahfiz.recitation_submitted': 'An aika da Karatu',
        'tahfiz.awaiting_feedback': 'Ana jiran bayanan malami',
        'tahfiz.previous_feedback': 'Bayanan da suka gabata',
        'tahfiz.rerecord_resubmit': 'Yi Rikodi kuma Aika Sake',
        'tahfiz.reviewed_by_teacher': 'Malami ya duba',
        'tahfiz.view_report': 'Duba Rahoto',
        'tahfiz.collapse': 'Rufe',
        'tahfiz.score': 'Maki',
        'tahfiz.no_ai_analysis': 'Ba a gudanar da nazarin AI ba — tambayi malaminku ya sake kimantawa da AI.',
        'tahfiz.mistakes_noted': 'Kurakuran da aka Lura',
        'tahfiz.recorded_by_teacher': 'Malami ya yi rikodi',
        'tahfiz.round': 'Zagaye',
        'tahfiz.your_recording': 'Rikodinku',
        'tahfiz.teacher_audio': 'Sauti na Malami',
        'tahfiz.no_sessions': 'Babu zamana da aka yi tukuna. Fara rikodi!',
        'tahfiz.assignments_from_teacher': 'Ayyuka daga Malamin Tahfiz',
        'tahfiz.no_tasks_desc': 'Malaminku zai sanya ayyukan haddace anan.',
        'tahfiz.no_active_goals': 'Babu manufofi masu aiki tukuna.',
        'tahfiz.set_to_start': 'Saita ɗaya don fara!',
        'tahfiz.no_sessions_short': 'Babu zamana da aka yi tukuna.',
        'tahfiz.earn_badges': 'Samu kyautu',
        'tahfiz.maintain_streaks': 'ta hanyar ci-gaba da jerin kwanaki da kammala manufofi!',
        'tahfiz.updating': 'Ana sabuntawa…',
        'tahfiz.select_teacher_placeholder': 'Zaɓi Malami...',
        'tahfiz.days_left': 'kwanaki masu zuwa',
        'tahfiz.days_remaining': 'kwanaki masu zuwa',
        'tahfiz.pace': 'Gurin',

        // ── Musabaqa ────────────────────────────────────────────────
        'musabaqa.title': 'Musabaqa ta Dijital',
        'musabaqa.subtitle': 'Gasar Karanta Alqurani',
        'musabaqa.my_competitions': 'Gasannina',
        'musabaqa.create_new': '+ Ƙirƙiri Sabuwar Gasa',
        'musabaqa.resume': 'Ci gaba',
        'musabaqa.tab_setup': 'Shirye-shirye',
        'musabaqa.tab_judges': 'Alkalai',
        'musabaqa.tab_draw': 'Zazzage',
        'musabaqa.tab_live': 'Rai',
        'musabaqa.tab_results': 'Sakamako',
        'musabaqa.comp_name': 'Sunan Gasa',
        'musabaqa.class': 'Aji',
        'musabaqa.date': 'Kwanan wata',
        'musabaqa.select_participants': 'Zaɓi Mahalarta',
        'musabaqa.deck_manager': 'Katin Ƙalubale',
        'musabaqa.regenerate_deck': 'Sake Ƙirƙirar Katuna',
        'musabaqa.scoring': 'Maki (100 pts)',
        'musabaqa.create_btn': 'Ƙirƙiri Gasa da Sanya Katuna',
        'musabaqa.creating': 'Ana ƙirƙirawa…',
        'musabaqa.judge_panel': 'Kwamitocin Alkalai',
        'musabaqa.judge_panel_desc': 'Gayyaci ma\'aikata na ciki ko alkalai na waje',
        'musabaqa.internal_staff': '🏫 Ma\'aikata na Ciki',
        'musabaqa.external': '🌐 Na Waje',
        'musabaqa.panel_members': 'Mambobin Kwamiti',
        'musabaqa.add_judge': 'Ƙara Alkali',
        'musabaqa.add_external': 'Ƙara Alkali na Waje',
        'musabaqa.added': 'An ƙara',
        'musabaqa.audience': 'Masu Kallo / Allo na Nuni',
        'musabaqa.audience_desc': 'Raba da iyaye ko nuna a allo — loda sakamako kai tsaye kawai.',
        'musabaqa.read_only': 'Karatu kawai',
        'musabaqa.send_email': '✉️ Aika Imel',
        'musabaqa.whatsapp': '📱 WhatsApp',
        'musabaqa.copy': 'Kwafi',
        'musabaqa.copied': '✓ An Kwafi',
        'musabaqa.assign_cards': 'Sanya Katuna',
        'musabaqa.assign_cards_desc': 'Zaɓi mahalarta da kati. Danna "Sanya" don zazzage masa.',
        'musabaqa.participant_tap': 'Mahalarta — danna don zaɓi, sanya har kati 4',
        'musabaqa.assign_btn': 'Sanya',
        'musabaqa.start_live': '🚀 Fara Gasar Rai',
        'musabaqa.assigned_cards': 'Katuna da aka Sanya',
        'musabaqa.now_reciting': 'Yana karanta yanzu',
        'musabaqa.competition_complete': 'Gasa ta ƙare!',
        'musabaqa.view_results': 'Duba Sakamako na ƙarshe →',
        'musabaqa.participant_queue': 'Jerin Mahalarta',
        'musabaqa.on_air': 'A ISKA',
        'musabaqa.done': '✓ An gama',
        'musabaqa.call_next': '← Kira Mai zuwa',
        'musabaqa.call_up': 'Kira',
        'musabaqa.score_btn': 'Bawa Maki',
        'musabaqa.mistake': 'KUSKURE',
        'musabaqa.change': 'CANZA',
        'musabaqa.end': 'ƘAREWA',
        'musabaqa.new_card': 'Sabon kati',
        'musabaqa.send_recording': 'Aika rikodi',
        'musabaqa.panel_judges': 'Alkalai na Kwamiti',
        'musabaqa.reveal_scores': 'Bayyana Maki',
        'musabaqa.panel_consensus': 'Yarjejeniyar Kwamiti',
        'musabaqa.scoring_panel_title': 'Bawa Maki',
        'musabaqa.notes': 'Bayani',
        'musabaqa.notes_placeholder': 'misali: Tajweed mai kyau, yana bukatar gyara Makharij...',
        'musabaqa.generate_ai': 'Ƙirƙiri Rahoton AI & Ajiye',
        'musabaqa.generating': 'Ana ƙirƙirar rahoto…',
        'musabaqa.champion': 'Gazan Musabaqa',
        'musabaqa.full_results': 'Cikakken Sakamako & Rahotanni',
        'musabaqa.download_pdf': 'Sauke Rahoton Hukuma PDF',
        'musabaqa.print_results': 'Buga / Fitar da Sakamako',
        'musabaqa.ai_report': 'Rahoto na AI',
        'musabaqa.connecting': 'Ana haɗa da gasa…',
        'musabaqa.invalid_link': 'Haɗin da ba daidai ba',
        'musabaqa.invalid_link_desc': 'Haɗin alkalin ba daidai ba ne ko kuma gasa ta ƙare. Tuntubi mai shirya gasa don sabon haɗi.',
        'musabaqa.session_ended': 'Zaman ya ƙare',
        'musabaqa.session_ended_teacher': 'Malami ya ƙare zaman Musabaqa.',
        'musabaqa.lobby_waiting': 'Ana loda Gasa…',
        'musabaqa.lobby_desc': 'Mai shirya yana shirye-shirye. Za a sanar da ku da zarar ya fara.',
        'musabaqa.score_reveal': 'Bayyana Maki',
        'musabaqa.judge_signals': 'Alamomin Alkali',
        'musabaqa.mistake_signal': 'Kuskure',
        'musabaqa.change_signal': 'Canza',
        'musabaqa.end_signal': 'Ƙarewa',
        'musabaqa.submit_scores': 'Aika Maki ✓',
        'musabaqa.submitting_scores': 'Ana aika…',
        'musabaqa.scores_submitted': 'An aika maki!',
        'musabaqa.waiting_reveal': 'Ana jiran alkalin shugaba ya bayyana maki…',
        'musabaqa.waiting_participant': 'Ana jiran mahalarta mai zuwa…',
        'musabaqa.live_leaderboard': 'Jerin Sakamako Rai',
        'musabaqa.final_rankings': 'Matsayin ƙarshe',
        'musabaqa.session_done': 'Zaman ya ƙare',
        'musabaqa.session_ended_awaiting': '✓ Zaman ya ƙare — Ana jiran ɗalibi ya aika rikodi',
        'musabaqa.judge_notes_placeholder': 'Bayanan zaɓi game da wannan karatu…',
        'musabaqa.no_results': 'Babu sakamako tukuna',
        'musabaqa.tajweed': 'Tajweed',
        'musabaqa.makharij': 'Makharij',
        'musabaqa.tarteel': 'Tarteel',
        'musabaqa.hifz': 'Hifz',
        'musabaqa.tajweed_desc': 'Dokokin Tajweed',
        'musabaqa.makharij_desc': 'Furta Haruffa',
        'musabaqa.tarteel_desc': 'Kyau da Tarteel',
        'musabaqa.hifz_desc': 'Haddacewa',
        'musabaqa.no_active': 'Babu Gasa mai Aiki',
        'musabaqa.no_active_desc': 'Babu gasa tana gudana a makarantar ku yanzu.',
        'musabaqa.go_back': 'Koma Baya',
        'musabaqa.final_leaderboard': 'Jerin ƙarshe',
        'musabaqa.your_scores': 'Makin ka',
        'musabaqa.total_score': 'Jimlar Maki',
        'musabaqa.comp_lobby': 'Zauren Jira na Gasa',
        'musabaqa.card_draw': 'Mataki na Zazzage Kati',
        'musabaqa.waiting_begin': 'Ana jiran malami ya fara gasa...',
        'musabaqa.cards_drawn': 'Ana zazzage katuna. Za a kira ku nan ba da jimawa ba.',
        'musabaqa.your_turn': 'Lokacin ka ya yi',
        'musabaqa.begin_recitation': 'Fara Karatu',
        'musabaqa.three_mistakes': 'Kuskure 3',
        'musabaqa.listen_carefully': 'Saurara sosai',
        'musabaqa.mistake_noted': 'An rubuta kuskure',
        'musabaqa.tap_to_start': 'Danna don fara karatu',
        'musabaqa.stop_submit': 'Tsaya & Aika Rikodi',
        'musabaqa.uploading': 'Ana loda...',
        'musabaqa.upload_recording': 'Loda Rikodi',
        'musabaqa.recording_submitted': 'An aika rikodi!',
        'musabaqa.your_status': 'Yanayin ka',
        'musabaqa.your_card': 'Katin da aka Sanya maka',
        'musabaqa.all_participants': 'Dukan Mahalarta',
        'musabaqa.comp_in_progress': 'Gasa tana gudana',
        'musabaqa.submitted_recording': 'Rikodi da aka Aika',
        'musabaqa.bronze': 'Bronze',
        'musabaqa.silver': 'Silver',
        'musabaqa.gold': 'Gold',
        'musabaqa.diamond': 'Diamond',
        'musabaqa.session_code': 'Lambar Zaman',
        'musabaqa.participants': 'mahalarta',
        'musabaqa.cancel': 'Soke',
        'musabaqa.delete': 'Goge',
        'musabaqa.competition_setup': 'Shirya Gasa',
        'musabaqa.head_judge': 'ALKALIN SHUGABA',
        'musabaqa.panel_judge': 'ALKALI NA KWAMITI',
        'musabaqa.observer': 'MAI KALLO',
        'musabaqa.welcome': 'Barka da zuwa',
        'musabaqa.final': 'ƙARSHE',
        'musabaqa.live': 'RAI',
    }
};
